import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { LocationsResource } from "api/resource/locations";
import { loginReset } from "redux/slice/authentication";

export interface LocationsState {
    loading?: boolean;
    error?: string | null;
    locations?: LocationsResource;
}

const initialState: LocationsState = {
    loading: false,
};

export const fetchLocations = createAsyncThunk("locations/fetch", async (_, thunkAPI) => {
    thunkAPI.dispatch(locationsLoading());
    const result = api.getLocations();
    result
        .then((s) => thunkAPI.dispatch(locationsLoaded(s)))
        .catch((e) => thunkAPI.dispatch(locationsFailed(e)));
    return result;
});

export const saveLocations = createAsyncThunk("locations/save", async (payload: LocationsResource, thunkAPI) => {
    thunkAPI.dispatch(locationsLoading());
    const result = api.updateLocations(payload);
    result
        .then((s) => thunkAPI.dispatch(locationsLoaded(s)))
        .catch((e) => thunkAPI.dispatch(locationsFailed(e)));
    return result;
});

export const locationsSlice = createSlice({
    name: "locations",
    initialState,
    reducers: {
        locationsLoading: (state) => {
            state.loading = true;
        },
        locationsLoaded: (state, action: PayloadAction<LocationsResource>) => {
            state.loading = false;
            state.error = null;
            state.locations = action.payload;
        },
        locationsFailed: (state, action: PayloadAction<any>) => {
            state.loading = false;
            state.error = action.payload.message;
        },
        default: (state) => {
            return state;
        },
    },
    extraReducers(builder) {
        builder.addCase(loginReset, () => {
            return initialState;
        });
    },
});

export const { locationsLoading, locationsLoaded, locationsFailed } = locationsSlice.actions;
